import { render } from "./gdrs.vue?vue&type=template&id=09ad2c3c&scoped=true&ts=true"
import script from "./gdrs.vue?vue&type=script&lang=ts"
export * from "./gdrs.vue?vue&type=script&lang=ts"

import "./gdrs.vue?vue&type=style&index=0&id=09ad2c3c&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ad2c3c"]])

export default __exports__